import React,{useState,useEffect} from 'react'
import { useNavigate } from 'react-router-dom';
import { updateStatusApi } from '../api/api';

import axios from 'axios'
const Redirect = () => {

  const navigate = useNavigate()

  // const [param,setParam] = useState(null)

  const queryParams = new URLSearchParams(window.location.search);
  const params = {};
  for (const [key, value] of queryParams.entries()) {
    params[key] = value;
    
  }


  const UpdateMessage=async()=>{

    console.log('update message called')
    try{
      const data ={
        message:params.message,
        reason:params.error,
        ext_ref:params.requestid
      }
      const res = await axios.post(updateStatusApi,data)
      console.log(res);
    }
    catch(err){
      console.log(err)
    }
  }



 

useEffect(()=>{
if(params.message.toLowerCase() == 'success'){
  UpdateMessage()
  navigate('/')
}
else{
  UpdateMessage()
}

},[])

// console.log(params);


console.log(params,'params---------')

  return (
    <>
    {
      params?.message.toLowerCase() == 'failure' &&
      
      
        <div  className='flex justify-center items-center h-[100vh] bg-black' >
         <div
      className="text-neutral-800 py-6 relative overflow-hidden flex flex-col justify-around w-[30rem] px-6 bg-white/5  border border-white/10 rounded-2xl p-5"
      
    >
   
      <div
        class=" flex flex-col items-center before:absolute before:w-32 before:h-20 before:right-2 before:bg-rose-300 before:-z-10 before:rounded-full before:blur-xl before:-top-12 z-10 after:absolute after:w-24 after:h-24 after:bg-orange-300 after:-z-10 after:rounded-full after:blur after:-top-12 after:-right-6"
      >
      <img src='/assets/images/kid.png' alt='' className='h-[5rem]'/>
        <p class=" text-2xl font-semibold text-orange-500 text-center">
        ** You Failed to Subscribe!!
        <br/>
        Try Again Later!! **
        </p>
        <br/>
      </div>
      
    </div>
    </div>
   
    
    }
    </>
  )
}

export default Redirect
